export default {
  MODAL_ACTIVE_CHANGED: 'MODAL_ACTIVE_CHANGED',
  DIALOG_ACTIVE_CHANGED: 'DIALOG_ACTIVE_CHANGED',
  DIALOG_DEVICEINFO_KEY_UPDATED: 'DIALOG_DEVICEINFO_KEY_UPDATED',
  DIALOG_DEVICEINFO_FETCH: 'DIALOG_DEVICEINFO_FETCH',
  DIALOG_DEVICEINFO_SUCCESS: 'DIALOG_DEVICEINFO_SUCCESS',
  DIALOG_DEVICEINFO_ERROR: 'DIALOG_DEVICEINFO_ERROR',
  DIALOG_DEVICEINFO_MORELOGS_FETCH: 'DIALOG_DEVICEINFO_MORELOGS_FETCH',
  DIALOG_DEVICEINFO_MORELOGS_SUCCESS: 'DIALOG_DEVICEINFO_MORELOGS_SUCCESS',
  DIALOG_DEVICEINFO_MORELOGS_ERROR: 'DIALOG_DEVICEINFO_MORELOGS_ERROR',
  DIALOG_DEVICEINFO_LATESTLOGS_FETCH: 'DIALOG_DEVICEINFO_LATESTLOGS_FETCH',
  DIALOG_DEVICEINFO_LATESTLOGS_SUCCESS: 'DIALOG_DEVICEINFO_LATESTLOGS_SUCCESS',
  DIALOG_DEVICEINFO_LATESTLOGS_ERROR: 'DIALOG_DEVICEINFO_LATESTLOGS_ERROR',
  DIALOG_TRANSFER_SETMODE: 'DIALOG_TRANSFER_SETMODE',
  DIALOG_TRANSFER_DEVICES_CHANGED: 'DIALOG_TRANSFER_DEVICES_CHANGED',
  DIALOG_TRANSFER_REQUEST_UPDATE_TRANSFER: 'DIALOG_TRANSFER_REQUEST_UPDATE_TRANSFER',
  DIALOG_TRANSFER_SEND_UPDATE_TRANSFER: 'DIALOG_TRANSFER_SEND_UPDATE_TRANSFER',
  DIALOG_TRANSFER_SEND_UPDATE_DEVICES: 'DIALOG_TRANSFER_SEND_UPDATE_DEVICES',
  DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_FETCH: 'DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_FETCH',
  DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_SUCCESS: 'DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_SUCCESS',
  DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_ERROR: 'DIALOG_TRANSFER_ACTIVITIES_CLOSED_MORELOGS_ERROR',
  DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_FETCH: 'DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_FETCH',
  DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_SUCCESS: 'DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_SUCCESS',
  DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_ERROR: 'DIALOG_TRANSFER_ACTIVITIES_CLOSED_LATESTLOGS_ERROR',
  DIALOG_TRANSFER_ACTIVITIES_OPEN_REMOVELOG: 'DIALOG_TRANSFER_ACTIVITIES_OPEN_REMOVELOG',
  DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_FETCH: 'DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_FETCH',
  DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_SUCCESS: 'DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_SUCCESS',
  DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_ERROR: 'DIALOG_TRANSFER_ACTIVITIES_OPEN_MORELOGS_ERROR',
  DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_FETCH: 'DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_FETCH',
  DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_SUCCESS: 'DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_SUCCESS',
  DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_ERROR: 'DIALOG_TRANSFER_ACTIVITIES_OPEN_LATESTLOGS_ERROR',
  DIALOG_READRIGHTS_INIT: 'DIALOG_READRIGHTS_INIT',
  DIALOG_READRIGHTS_SETCONFIRMED: 'DIALOG_READRIGHTS_SETCONFIRMED',
  DIALOG_READRIGHTS_SETITEMS: 'DIALOG_READRIGHTS_SETITEMS',
  DIALOG_READRIGHTS_SETMODE: 'DIALOG_READRIGHTS_SETMODE',
  DIALOG_READRIGHTS_UPDATE_ASSIGNEE: 'DIALOG_READRIGHTS_UPDATE_ASSIGNEE',
  DIALOG_READRIGHTS_ASSIGN_FETCH: 'DIALOG_READRIGHTS_ASSIGN_FETCH',
  DIALOG_READRIGHTS_ASSIGN_SUCCESS: 'DIALOG_READRIGHTS_ASSIGN_SUCCESS',
  DIALOG_READRIGHTS_ASSIGN_ERROR: 'DIALOG_READRIGHTS_ASSIGN_ERROR',
  DIALOG_READRIGHTS_REMOVE_FETCH: 'DIALOG_READRIGHTS_REMOVE_FETCH',
  DIALOG_READRIGHTS_REMOVE_SUCCESS: 'DIALOG_READRIGHTS_REMOVE_SUCCESS',
  DIALOG_READRIGHTS_REMOVE_ERROR: 'DIALOG_READRIGHTS_REMOVE_ERROR',
  DIALOG_DOWNLOAD_INIT: 'DIALOG_DOWNLOAD_INIT',
  DIALOG_DOWNLOAD_SETITEMS: 'DIALOG_DOWNLOAD_SETITEMS',
  DIALOG_DOWNLOAD_SETMODE: 'DIALOG_DOWNLOAD_SETMODE',
  DIALOG_DOWNLOAD_FETCH: 'DIALOG_DOWNLOAD_FETCH',
  DIALOG_DOWNLOAD_SUCCESS: 'DIALOG_DOWNLOAD_SUCCESS',
  DIALOG_DOWNLOAD_ERROR: 'DIALOG_DOWNLOAD_ERROR',
  DIALOG_DOWNLOAD_MORELOGS_FETCH: 'DIALOG_DOWNLOAD_MORELOGS_FETCH',
  DIALOG_DOWNLOAD_MORELOGS_SUCCESS: 'DIALOG_DOWNLOAD_MORELOGS_SUCCESS',
  DIALOG_DOWNLOAD_MORELOGS_ERROR: 'DIALOG_DOWNLOAD_MORELOGS_ERROR',
  DIALOG_DOWNLOAD_LATESTLOGS_FETCH: 'DIALOG_DOWNLOAD_LATESTLOGS_FETCH',
  DIALOG_DOWNLOAD_LATESTLOGS_SUCCESS: 'DIALOG_DOWNLOAD_LATESTLOGS_SUCCESS',
  DIALOG_DOWNLOAD_LATESTLOGS_ERROR: 'DIALOG_DOWNLOAD_LATESTLOGS_ERROR',
  DIALOG_REGISTER_SETTINGS_UPDATED: 'DIALOG_REGISTER_SETTINGS_UPDATED',
  DIALOG_REGISTER_FETCH: 'DIALOG_REGISTER_FETCH',
  DIALOG_REGISTER_SUCCESS: 'DIALOG_REGISTER_SUCCESS',
  DIALOG_REGISTER_ERROR: 'DIALOG_REGISTER_ERROR',
  DIALOG_REGISTER_VALIDATE_FETCH: 'DIALOG_REGISTER_VALIDATE_FETCH',
  DIALOG_REGISTER_VALIDATE_SUCCESS: 'DIALOG_REGISTER_VALIDATE_SUCCESS',
  DIALOG_REGISTER_VALIDATE_ERROR: 'DIALOG_REGISTER_VALIDATE_ERROR',
};
